import React from 'react'
import './DeltaTrialLoader.scss'

export interface DeltaTrialLoaderProps {
  message?: string
}

export const DeltaTrialLoader: React.FC<DeltaTrialLoaderProps> = ({ message }) => {
  return (
    <div className='d-flex flex-column zocks-gap-0.75 align-items-center justify-content-center'>
      <div className='delta-trial-loader' />
      {message ? <h5>{message}</h5> : null}
    </div>
  )
}
